import { render, staticRenderFns } from "./FundingBreakdown.vue?vue&type=template&id=f2f65690"
import script from "./FundingBreakdown.vue?vue&type=script&lang=js"
export * from "./FundingBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports